import { UseQueryOptions } from '@tanstack/react-query';
import { ResourceCategoryParameters, ResourceCategoryResult, useRepositoryQuery } from '@mews-commander/data-access';

type QueryParams = Pick<ResourceCategoryParameters, 'enterpriseId' | 'serviceIds'>;
export const useResourceCategoryQuery = (
    params: QueryParams,
    options?: Omit<UseQueryOptions<ResourceCategoryResult>, 'queryKey'>
) => useRepositoryQuery('resourceCategories', 'getAll', params, options);
